import { mainnet, goerli, sepolia } from 'wagmi/chains'
import { Chain } from 'wagmi'
import { createConfig, configureChains  } from 'wagmi'

import { alchemyProvider } from 'wagmi/providers/alchemy'
import { publicProvider } from 'wagmi/providers/public'
import { jsonRpcProvider } from '@wagmi/core/providers/jsonRpc'
import { InjectedConnector } from 'wagmi/connectors/injected'
import {WalletConnectConnector} from 'wagmi/connectors/walletConnect'
//import { coinbaseWallet, injected, walletConnect, metaMask, safe   } from 'wagmi/connectors'

export function abbreviateAddress(address: string, charsLength: number = 4): string {
  if (typeof address !== 'string') return '';
  if (address.length < charsLength * 2 + 2) return address;

  const prefix = address.substr(0, charsLength + 2); // '0x' + charsLength characters
  const suffix = address.substr(-charsLength);

  return `${prefix}...${suffix}`;
}


export const abstract = {
  id: 2741, // TODOO
  name: 'Abstract',
  network: 'abstract',
  nativeCurrency: {
    decimals: 18,
    name: 'Ethereum',
    symbol: 'ETH',
  },
  rpcUrls: {

    //public: { http: ['https://api.abs.xyz'] },
    //default: { http: ['https://api.abs.xyz'] }, // TODO: use alchemy here?????
    public: { http: ['https://api.mainnet.abs.xyz'] },
    default: { http: ['https://api.mainnet.abs.xyz'] }, 
    //public: { http: ['https://abstract-mainnet.g.alchemy.com/v2/k5u1H1zQC3iHJZJGTUzZeUpw11HbzT0L'] },
    //default: { http: ['https://abstract-mainnet.g.alchemy.com/v2/k5u1H1zQC3iHJZJGTUzZeUpw11HbzT0L'] }, 
    
  },
  blockExplorers: {
    etherscan: { name: 'Abstract Explorer', url: 'https://explorer.abs.xyz' },
    default: { name: 'Abstract Explorer', url: 'https://explorer.abs.xyz' },
  }
} 


export const abstracttestnet = {
  id: 11124,
  name: 'Abstract Testnet',
  network: 'abstracttestnet',
  nativeCurrency: {
    decimals: 18,
    name: 'Ethereum',
    symbol: 'ETH',
  },
  rpcUrls: {
    //public: { http: ['https://sepolia.unichain.org'] },
    //default: { http: ['https://sepolia.unichain.org'] },

    public: { http: ['https://abstract-testnet.g.alchemy.com/v2/k5u1H1zQC3iHJZJGTUzZeUpw11HbzT0L'] },
    default: { http: ['https://abstract-testnet.g.alchemy.com/v2/k5u1H1zQC3iHJZJGTUzZeUpw11HbzT0L'] },
    //default: { http: ['https://api.testnet.abs.xyz'] },
    
    
  },
  blockExplorers: {
    etherscan: { name: 'Abstract Testnet Explorer', url: 'https://explorer.testnet.abs.xyz' },
    default: { name: 'Abstract Testnet Explorer', url: 'https://explorer.testnet.abs.xyz' },
  }
} 


const getEtherScan = () => {
  switch (chain.network) {
    case "blast":  return "https://blastscan.io";
    case "blastsepolia":  return "https://testnet.blastscan.io";
    //case "unichain":  return "https://uniscan.xyz";
    case "unichain":  return "https://unichain.blockscout.com";
    case "unichainsepolia":  return "https://sepolia.uniscan.xyz";
    case "sepolia":  return "https://sepolia.etherscan.io";
    case "goerli":  return "https://goerli.etherscan.io";
    case "abstract":  return "https://abscan.org";
    case "abstracttestnet":  return "https://explorer.testnet.abs.xyz";
  }
}

export const chain = abstract; // testnet
//export const chain = abstracttestnet; // testnet

export const getEtherscanAddressLink = (hash) => {
  return `${getEtherScan()}/address/${hash}`;
}

export const getEtherscanTxnLink = (hash) => {
  return `${getEtherScan()}/tx/${hash}`;
}

export const getEtherscanContractLink = (hash) => {
  return `${getEtherScan()}/address/${hash}`;
}

export const links = {
  twitter: "https://x.com/dailofrog",
  twitterGoop: "https://x.com/goopgoop_art",
  linktree: "https://linktr.ee/dailofrog",
  discord: "https://discord.gg/KBAbk2a4PM",
  contractFrontEnd: getEtherscanContractLink(process.env.REACT_APP_CONTRACT_ERC721),
  opensea: "https://opensea.io/collection/",
  magicEden: "https://magiceden.io/collections/abstract/0xb47a26df28923bc826100256e7d5fa01cd0817a7",
  mintify: "https://mintify.xyz/abstract/0xb47A26dF28923bc826100256E7d5FA01CD0817A7",
  unichain: "https://www.unichain.org/",
  abstract: "https://abs.xyz/",
};

export const data = {
  hidden: false, 

  totalSupply: 3333,
  pricePublic: "0.0069",
  priceWhitelist: "0.005",
  
  ticker: "$DERPLET",
}


const { chains, publicClient, webSocketPublicClient  } = configureChains(
  [chain],
  [
    //alchemyProvider({ apiKey: process.env.REACT_APP_ALCHEMY_API_KEY }),
    //publicProvider(),

    jsonRpcProvider({
      rpc: (chain) => ({
        http: chain.rpcUrls.public.http[0],
        //http: "https://rpc.ankr.com/blast_testnet_sepolia/13bc3e5c2b4ca20f87bf24426fde9530951c2ee4b658c542f919396d3ffb90f1",
      }),
    }),

  ],
)

export const wagmiConfig = createConfig({
  autoConnect: true,
  publicClient,
  connectors: [
    new InjectedConnector({ chains }),
    new WalletConnectConnector({chains, 
      options: { projectId: "577741f86c194e5900ea77f7693f805d", metadata:{name:"tinyass unicorns", url:"https://tinyunicorns.xyz"}}
    }),
    //metaMask(),
    //coinbaseWallet({ appName: 'tinyass unicorns', preference: 'smartWalletOnly',headlessMode: false,   }),
    //walletConnect({ projectId: process.env.NEXT_PUBLIC_WALLETCONNECT_PROJECT_ID, metadata:{name:"HYPERLANDS", url:"https://hyperlands.art"} }),
    //safe()
  ],
  ssr: true,
  webSocketPublicClient
});

if (!data.hidden) {
  console.log(`Chain: ${chain.name} (${chain.id})`);
  console.log(`Derplets.sol: ${getEtherscanContractLink(process.env.REACT_APP_CONTRACT_ERC721)}`)
}